const config = {
    // Note: There should not be trailing / and the end
    // API_URL: 'https://app-ad451122-4612-4f95-809a-a15dc56ab6f9.cleverapps.io',
    //API_URL: 'http://localhost:3000',
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GMAP_KEY,
    API_URL: process.env.REACT_APP_API_URL,
};
export default config;
